<div class="shell">
  <aside class="shell__menu">
    <!--
      Official brand logo. Empty `alt` plus aria-label on the container: the brand
      name is decorative here (the screen reader already announces the navigation
      region), and repeating "Getnet" on every pass would only add noise.
    -->
    <div class="shell__brand" role="img" aria-label="Getnet">
      <img class="shell__logo" src="assets/getnet/logo-getnet.png" alt="" />
    </div>

    <nav class="shell__nav" aria-label="Navegação principal">
      @for (item of items; track item.route) {
        <a
          class="shell__item"
          [routerLink]="item.route"
          routerLinkActive="shell__item--active"
          [routerLinkActiveOptions]="{ exact: false }"
          [attr.aria-label]="item.label"
        >
          <i class="shell__icon" [class]="item.icon" aria-hidden="true"></i>
          <span>{{ item.label }}</span>
        </a>
      }
    </nav>
  </aside>

  <div class="shell__content">
    @if (pageTitle()) {
      <header class="shell__header">
        <h1 class="shell__title">{{ pageTitle() }}</h1>
      </header>
    }

    <router-outlet />
  </div>
</div>
